import React, { Fragment, useState, useEffect, useRef } from "react";
import { useTranslation } from 'react-i18next';
import $, { error } from 'jquery';
import { Container, Form, Row, Col, Card, Button, CardBody } from "react-bootstrap";
import Cookies from 'js-cookie';
import AOS from 'aos';
const { config } = require('../../api/api');
function SanadMotor() {

    const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';
    const vendor_key = 'c3VwZXJqZXRfc2FuYWRfcGVyc29uYWxfYWNjaWRlbnRfdmVuZG9yX2tleQ==';
    const api_headers = {
        'Authorization': 'Bearer ' + vendor_key,
        'Content-Type': 'application/json' // Ensure you're sending JSON
    }
    const base_url = config.baseURL;
    const redirecturl = config.redirectURL;


    const { t } = useTranslation();

    const [formData, setFormData] = useState({
        insurancetype: '',
    });

    const [selected, setSelected] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showSection, setShowSection] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [isHovered1, setIsHovered1] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [show1, setShow1] = useState(false);
    const [show2, setShow2] = useState(false);
    const [showquote, setShowQuote] = useState(false);

    const [isEmailActive, setEmailActive] = useState(false);
    const [isMobilenoActive, setMoblienoActive] = useState(false);
    const [isWhatappActive, setWhatappActive] = useState(false);
    

      const [name, setfnameValue] = useState("");
      const [email, setEmailvalue] = useState("");
      const [mobileno, setMobilevalue] = useState("");
      const [lastName, setLastName] = useState("");
      const [emailError, setEmailError] = useState("");
      const [plantype , setPlantype] = useState("");
 const [vendorKey,setVendorkey]=useState(null);
        
      

        const [formData1,setFormData1]=useState({
        plate_number:"",
        plate_code:"",
        chasis_no:"",
        vehicle_value:"",
        civil_id:"",
        plate_reg_type:"",
        registration_mark:""
        });
    const [nameError, setNameError] = useState("");
    const [lastNameError, setLastNameError] = useState("");
    const [mobilenoError, setMobilenoError] = useState("");
    const [errors, setErrors] = useState({});
    const [isHidePage,setIsHidePage]=useState("");
    const [sanadDetails,setSanadDetails]=useState(null);
    const [openPaymentOption,setOpenPaymentOption]=useState(false);

    const reg_type = ["Oman Plate", "GCC Plate", "Import", "Export"];
    const reg_mark = [
          "10", "11", "12", "14", "15", "16", 
          "A A", "B K", "D D", "H W", "A D", "M", "A R", "H H", 
          "L K", "H A", "B M", "BANK", "C D", "D A", "Inspection", 
          "M B", "M S", "MUSCAT", "R A", "R H", "T", "T B", "W A", 
          "1", "2", "3", "4", "5", "6", "7", "8", "9", "L D", "M L", 
          "M Y", "Y M", "Y R", "M W", "R R", "T A", "T B A", "Y", 
          "A W", "K B", "L A", "K H", "M D", "M K", "R W", "Y W", 
          "A Y", "B B", "B H", "D H", "D Y", "H", "I N T L", "K", 
          "D R", "D S", "H Y", "IMPORT", "J", "K A", "B R", "B S", 
          "D", "D W", "H K", "H M", "H R", "R", "T T", "Y A", "Y B", 
          "R K", "R S", "W", "Y D", "Y Y", "K K", "S S", "Y S", "A", 
          "B", "B D", "A B", "A K", "A S", "B W", "B Y", "D K", 
          "H D", "H S", "M A", "A M", "M M", "M R", "R M", "S", 
          "S H", "W B", "W K", "T H", "T D", "R Y", "W W", "L B", 
          "L A", "L H", "B A", "M H", "17", "18", "19", "20", "21", 
          "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", 
          "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", 
          "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", 
          "52", "53", "54", "55", "56", "57", "58", "59", "60", "61", 
          "62", "63", "64", "65", "66", "67", "68", "69", "70", "71", 
          "72", "73", "74", "75", "76", "77", "78", "79", "80", "81", 
          "82", "83", "84", "85", "86", "87", "88", "89", "90", "91", 
          "92", "999", "UAE", "Dubai", "Abu Dhabi", "Fujairah", "Sharjah", 
          "Qatar", "Kuwait", "KSA", "Ras Al - Khaimah", "Umm Al - Quwain", 
          "Ajman", "Bahrain"
        ];
    const selectOpt1=useRef(null);

      const handleChange=(e)=>{
    const name=e.target.name;
    const value= e.target.value;
    setFormData1((data)=>({...data,[name]:value}));
    setErrors((prevErrors) => ({
    ...prevErrors,
    [name]: ''
  }));
    }




         const [quoteDetails,setQuoteDetails]=useState(null);
         const [vehicleDetails,setVehicleDetails]=useState(null);
         const [insuredDetails,setInsuredDetails]=useState(null);
         const [transactionDetails,setTransactionDetails]=useState(null)


        useEffect(() => {
            $(selectOpt1.current).select2({width:"100%"});
            $(selectOpt1.current).on('select2:select', (e) => {
                debugger
                const selectedValue = e.params.data.text;
                const selected_id = e.params.data.id;
        
                setFormData1((data)=>({...data,["registration_mark"]:selected_id}));
                    setErrors((prevErrors) => ({
      ...prevErrors,
      registration_mark: '' 
    }));

                
            });
        
          return () => {
            $(selectOpt1.current).select2('destroy');
          };
        }, []);



    // const handleOptionChange = (event) => {
    //     setSelected(event.target.value);
    //     setShowQuote(true);
    //     debugger
    //     setFormData({ ...formData, 'insurancetype': event.target.value });

    //     if (event.target.value === ' ') {
    //         setShowSection(true);
    //         setButtonDisabled(true);
    //     }
    //     else {
    //         setShowSection(false);
    //         setButtonDisabled(false);
    //     }

    // };

    const popupStyle = {
        position: 'fixed',
        width: '50%',
        top: '50%',
        left: '48%',
        transform: 'translate(-50%, -50%)',
        padding: '20px',
        background: 'white',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        zIndex: 1000,
        borderRadius: '8px',
    };


    const togglePopup = () => {
        debugger
        setIsOpen(!isOpen);
    };
    const handleClosePopup = () => {
        setIsOpen(false);
    };

    const handleshow1 = async (event) => {
        debugger
        event.preventDefault();
        setPlantype("third party");
        const isvalid = await verifyfield();
        if (!isvalid) {
            return;
        }else{
            setShow1(true);
            setShow2(false);
        }
        
    }

    const handleshow2 = async (event) => {
        debugger
        event.preventDefault();
        setPlantype("comprehensive");
        const isvalid = await verifyfield();
        if (!isvalid) {
            return;
        }else{
        setShow1(false);
        setShow2(true);
        }
    }

    const handlesuccess = async (event) => {
        event.preventDefault();
        window.location.href = '/dhofar-motor-success'
    };


    const createAccessToken = async () => {
        try {
            const response = await fetch(base_url + '/create_sanad_personal_accident_token', {
                method: 'GET',
                headers: api_headers
            });
            const data = await response.ok ? await response.json() : Promise.reject('Network response was not ok');
            if (data.message === 'success') {
                return data;
            } else {
                return null;
            }
        } catch (error) {
            return null;
        }
    };


    const handlefnameChange = (event) => {
    setfnameValue(event.target.value);
    setNameError("")
  };
  const handlelnameChange = (event) => {
    setLastName(event.target.value);
    setLastNameError("");
  };

  const handleEmailchange = (event) => {
    setEmailvalue(event.target.value);
    setEmailError(""); 
  };

  const handleMobileChange = (event) => {
    setMobilevalue(event.target.value);
    setMobilenoError("");
  };

   const handleEmailBlur = (e) => {
    const { value } = e.target;

    // Regular expression to validate a basic email format
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // Check if the email matches the pattern
    if (!emailPattern.test(value)) {
      setEmailError("Please enter a valid email address");
      setEmailvalue("");
    } else {
      setEmailError(""); // Clear the error if valid
    }
  };

  const validateForm = () => {
  const newErrors = {};

  if (!formData1.plate_number.trim()) {
    newErrors.plate_number = "Plate number is required";
  }

  if (!formData1.plate_code.trim()) {
    newErrors.plate_code = "Plate code is required";
  }

  if (!formData1.chasis_no.trim()) {
    newErrors.chasis_no = "Chassis number is required";
  }

  if (!formData1.vehicle_value.trim()) {
    newErrors.vehicle_value = "Vehicle value is required";
  }

  if (!formData1.civil_id.trim()) {
    newErrors.civil_id = "Civil ID is required";
  }

  if (!formData1.plate_reg_type.trim()) {
    newErrors.plate_reg_type = "Plate registration type is required";
  }

  if (!formData1.registration_mark.trim()) {
    newErrors.registration_mark = "Registration mark is required";
  }

  setErrors(newErrors);

  // Return boolean indicating if form is valid
  return Object.keys(newErrors).length === 0;
};

  const verifyfield = async () => {
  let valid = true;

  // Reset all errors first
  setNameError('');
  setLastNameError('');
  setEmailError('');
  setMobilenoError('');

  if (!name) {
    setNameError('Please enter your first name');
    valid = false;
  }

  if (!lastName) {
    setLastNameError('Please enter your last name');
    valid = false;
  }

  if (!email) {
    setEmailError('Please enter your email');
    valid = false;
  }

  if (!mobileno) {
    setMobilenoError('Please enter your mobile number');
    valid = false;
  } else if (mobileno.length < 8) {
    setMobilenoError('Please enter a valid mobile number');
    valid = false;
  }

  const isFormData1Valid = validateForm(); 

  if (!valid || !isFormData1Valid) {
    return false;  
  }

  console.log("All inputs are valid. Proceeding...");
  return true; 
};

const handleOptionChange = (e) => {
    debugger
    const name=e.target.name;
    const value=e.target.value;
    const plan_id= e.target.getAttribute('data-name');
    setSelected((data)=>(
      {...data,
      planType:"comprehensive",
      plan:value,
      product:name,
      planId:plan_id
    }
    ));
    debugger
   

    if (e.target.value === ' ') {
      setShowSection(true);
      setButtonDisabled(true);
    }
    else {
      setShowSection(false);
      setButtonDisabled(false);
    }

  };


  
    useEffect( () => {
      debugger;
        // update sanad data in superjet
        const urlSearchString = window.location.search;
        const uparams = new URLSearchParams(urlSearchString);
        const sanadUserName = uparams.get('SANADUSERNAME');
        const sanadRequesteeName = uparams.get('REQUESTEENAME');
        const sanadUserMobileNumber = uparams.get('REQUESTEEMOBILENO');
        const sanadReferenceNumber = uparams.get('SANADREFNUMBER');
        const sanadCivilIDNumber = uparams.get('REQUESTEECIVILNO');
        const sanadAccessToken = uparams.get('SANADACCESSTOKEN');
        const sanad_ServiceRequestId = uparams.get('SERVICEREQUESTID');
        const sanad_TransDate = uparams.get('TRANSDATE');
        const sanad_ReturnUrl = uparams.get('RETURNURL');
        const sanad_ErrorUrl = uparams.get('ERRORURL');
        const sanad_BackUrl = uparams.get('BACKURL');
        const sanad_Language = uparams.get('LANGUAGE');
       
      
        
        let sanad_details={
          sanad_user_name:sanadUserName,
          sanad_request_name:sanadRequesteeName,
          mobile_no:sanadUserMobileNumber,
          sanad_reference_no:sanadReferenceNumber,
          sanad_civil_no:sanadCivilIDNumber,
          sanad_request_id:sanad_ServiceRequestId,
          trans_date:sanad_TransDate,
          return_url:sanad_ReturnUrl,
          error_url:sanad_ErrorUrl,
          back_url:sanad_BackUrl,
          language:sanad_Language
          
        }

        if (sanadAccessToken === "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImFkbWluQHNhbmFkLmNvbSIsInBhc3N3b3JkIjoiMTIzNCIsImlhdCI6MTcyODA1MjA0NywiZXhwIjoxNzI4MDUyOTQ3fQ.ucyIy6q6ovSDstXZL1zO-9swTAGYFeypV0uo8_rQJJc") {
            setIsHidePage('success');
            setSanadDetails(sanad_details);
        } else {
            setIsHidePage('fail');
        }
        // var sanad_urls_data = {
        //     'back_url': sanad_BackUrl,
        //     'return_url': sanad_ReturnUrl,
        //     'error_url': sanad_ErrorUrl,
        // }
        // debugger
        //    sessionStorage.setItem("sanadUrlData", JSON.stringify(sanad_urls_data));
        // const expiryDate = new Date();
        // expiryDate.setTime(expiryDate.getTime() + (1 * 60 * 60 * 1000));
        // Cookies.set('sanadUrlData', JSON.stringify(sanad_urls_data), { expires: expiryDate });
       
    }, []);

 


     const makePayment=async(e)=>{
      e.preventDefault();
      
            const req_data={
              quoteNo:quoteDetails?.renewalQuoteNo || transactionDetails?.quoteNo,
              srcBusId:"BOT"   
            }
           try{
            const response =await fetch(base_url+"/motor_payments",{
               method:"POST",
               headers:{
                Authorization:"Bearer "+vendor_key,
                "Content-Type":"application/json"
               },
               body:JSON.stringify(req_data)
            });

            const data= await response.json();

          if (data.message === "success") {
  const payment_link = data.result.transactionDetails.pgUrl;
  const anchor = document.createElement("a");
  anchor.setAttribute("href", payment_link);
 
  anchor.click();
} 

           }catch(err){
            console.error("err at make payment api "+ err)
           }

        }


const createQuote=async(e)=>{
    debugger
    e.preventDefault();

    const product_id=plantype?.toLowerCase() ==="comprehensive"? "0501":"0502";
    const quoteReqData={
      product:product_id,
      riskType:selected.planId ,
      plateNo:formData1.plate_number,
      registrationMark:formData1.registration_mark,
      srcBusId: "BOT",
      chasisNo: formData1.chasis_no || "",
      plateRegType:formData1.plate_reg_type,
      vehicleValue:formData1.vehicle_value,
      civilId:formData1.civil_id,
      mobileNo:mobileno,
      emailId:email,
      firstName:name,
      lastName:lastName,
      sanad_policy:sanadDetails
  }
  try{
      const response=await fetch(base_url+"/motor_create_new_quote",{
        method:"POST",
        headers:{
          Authorization:`Bearer ${vendor_key}`,
          'Content-Type':"application/json"
        },
         body:JSON.stringify(quoteReqData)
      });
      if(!response.ok){
        console.log("creating  quote HTTP status :",response.status )
      }
      const data= await response.json();
      if(data.message==="success"){
  
        if(data.result.effectiveDt ){


          // const quote_info=data.result;
          //   const session_data={
          //     civilId:quote_info?.insuredDetails?.insuredLicNo,
          //     plateNo: quote_info?.vehicleDetails?.vehRegNo,
          //     registrationMark:quote_info?.vehicleDetails?.vehRegLOC,
          //     srcBusId: "BOT",
          //     txnTyp:"Q",
          //     mobileNo:quote_info?.insuredDetails?.insuredMobileNo,
          //     policyNo:quote_info?.renewalQuoteNo ||"107/0502/2025/Q/000742",
          //     quoteNo:""
          // }

           setQuoteDetails(data.result);
        setVehicleDetails(data.result.vehicleDetails);
        setInsuredDetails(data.result.insuredDetails);
        setTransactionDetails(data.result.transactionDetails?data.result.transactionDetails:null);
          setOpenPaymentOption(true);
        
        }
        else if(data.result==="Reference no already exists."){
          alert(data.result);
        }
        else{
        alert(data.result.errMsg);
      
        }
    
      }
    }catch(err){
      console.log("err at creating quote : ",err)
  
    }

    
    
    
      
  }



    const Popup = ({ onClose }) => {

        return (
            // <div style={popupOverlayStyle} className="popup-overlay">

            <div style={popupStyle} className="popup-container p-3" data-aos='fade-up'>

                <button
                    type="button"
                    onClick={handleClosePopup}
                    style={{
                        position: 'absolute',
                        top: '1px',
                        right: '10px',
                        fontSize: '24px',
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        color: 'black'
                    }}
                >
                    <span>&times;</span>
                </button>

                <form>
                    <div className="center">Comprehensive Insurance</div>

                    <div className="d-flex justify-content-between my-3 colmds-4 card m-0">
                        <div className="d-flex justify-content-between my-3">
                            <div>
                                <h4><strong>Plan</strong></h4>
                                <h6>Basic + Medex + Driver + Family (PAB) + UAE</h6>
                            </div>
                        </div>
                    </div>
                    <div>
                        <ul className="list-unstyled">
                            <li><h6>Coverage</h6></li>
                            <li><p>Basic</p></li>
                            <li><p>Medical Expenses</p></li>
                            <li><p>Personal Accident Benefit for Driver</p></li>
                            <li><p>Personal Accident Benefit for Family</p></li>
                            <li><p>UAE Geographical Cover</p></li>
                        </ul>
                    </div>
                </form>

            </div>

            // </div>  
        );
    }

    return (
 isHidePage === 'success' ? 
        <Fragment>
            <form className="visa-form1">
                <div style={{ display: 'flex', paddingBottom: '20px' }}>
                    <button style={{ width: '100px', fontWeight: 'bold' }}>
                        Back
                    </button>
                </div>
                
                {

                openPaymentOption===false &&
                <>
                <div className="row mb-3">
                    <div className="col-md-12">
                        <div>
                            <div className="row mb-3">
                                <div className="col-md-6 text-start">
                                    <h2>Get Motor Insurance Offers</h2>
                                </div>
                                <div className="col-md-6 text-right">
                                    احصل على عروض التأمين على السيارات
                                </div>
                            </div>


                            <div className='inside_visa-form'>
                                <div className="row mb-2">
                        <div className="d-flex w-100 justify-content-between ">
                            <h2><u>Personal Details</u></h2>
                       
                            <h2><u>التفاصيل الشخصية</u></h2>
                        </div>
                    </div>
            <div className='row mb-3'>


                

              <div className='col-md-4'>

                <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span>First Name<span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                  <span>الاسم الأول</span></label>
                <input
                  type='text'
                  className='form-control'
                  value={name}
                  name='firstName'
                  onChange={handlefnameChange}
                //   onBlur={handleNameBlurtenant} // Validate on blur (when user leaves the field)
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                  }}
                />
                {nameError && <p style={{ color: 'red' }}>{nameError}</p>}
              </div>
              <div className='col-md-4'>
                <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span>
                     Last Name<span style={{ color: "red" }}>*</span>
                  </span>
                  <span style={{ textAlign: "right", direction: "rtl" }}>
                    اسم العائلة  
                  </span>
                </label>
                <input
                  type='text'
                  className='form-control'
                  name='lastname'
                  value={lastName}
                  onChange={handlelnameChange}
                //   onBlur={handleEmailBlurtenant} // Validate on blur (when user leaves the field)
                onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                  }}
                />
                {lastNameError && <p style={{ color: 'red' }}>{lastNameError}</p>} 
              </div>

              <div className='col-md-4'>
                <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span>
                    Email ID <span style={{ color: "red" }}>*</span>
                  </span>
                  <span style={{ textAlign: "right", direction: "rtl" }}>
                    معرف البريد الإلكتروني
                  </span>
                </label>
                <input
                  type='email'
                  className='form-control'
                  name='email'
                  value={email}
                  onChange={handleEmailchange}
                  onBlur={handleEmailBlur}
                //   onBlur={handleEmailBlurtenant} // Validate on blur (when user leaves the field)
                />
                {emailError && <p style={{ color: 'red' }}>{emailError}</p>} 
              </div>


              

            </div>






            <div className='row mb-3'>


                <div className="col-md-4">
                <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span>
                    Code <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                  </span>
                  <span style={{ textAlign: "right", direction: "rtl" }}>
                    شفرة
                  </span>
                </label>
                <input
                  type='text'
                  className='form-control'
                  name='mobilecode'
                  readOnly
                  value = '968'
                
                  />
               </div>

              <div className='col-md-4'>

                <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span>
                    Mobile Number <span style={{ color: "red" }}>*</span>
                  </span>
                  <span style={{ textAlign: "right", direction: "rtl" }}>
                    رقم الجوال
                  </span>
                </label>
                <input
                  type='tel'
                  className='form-control'
                  name='mobileNumber'
                  value={mobileno}
                  onChange={handleMobileChange}
                  maxLength={8} // Enforce max length in the UI
                //   onBlur={handleMobileBlurtenant} // Validate on blur (when user leaves the field)
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                  }}
                  />
                {mobilenoError && <p style={{ color: 'red' }}>{mobilenoError}</p>} 


              </div>

              <div className='col-md-4'>

                <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span>
                    Civil ID <span style={{ color: "red" }}>*</span>
                  </span>
                  <span style={{ textAlign: "right", direction: "rtl" }}>
                    البطاقة المدنية
                  </span>
                </label>
                <input
                                                type='tel'
                                                className='form-control'
                                                name='civil_id'
                                                value={formData1.civil_id}
                                                onChange={handleChange}
                                                />
                                                {errors.civil_id && <p style={{ color: 'red' }}>{errors.civil_id}</p>}


              </div>

            </div>

            <div className="row mb-2">
                       <div className="d-flex w-100 justify-content-between ">
                            <h2><u>Vehicle Details</u></h2>
                      
                            <h2><u>تفاصيل المركبة</u></h2>
                        </div>
                    </div>

                    <div className='row mb-3'>


                <div className="col-md-4">
                <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span>
                    Plate Number <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                  </span>
                  <span style={{ textAlign: "right", direction: "rtl" }}>
                    رقم اللوحة
                  </span>
                </label>
                <input
                                                        type='text'
                                                        className='form-control'
                                                        name='plate_number'
                                                        value={formData1.plate_number}
                                                        onChange={handleChange}
                                                        />
                                                        {errors.plate_number && <p style={{ color: 'red' }}>{errors.plate_number}</p>}
               </div>

              <div className='col-md-4'>

                <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span>
                    Plate Code<span style={{ color: "red" }}>*</span>
                  </span>
                  <span style={{ textAlign: "right", direction: "rtl" }}>
                    رمز اللوحة 
                  </span>
                </label>
                <input
                                                        type='text'
                                                        className='form-control'
                                                        name='plate_code'
                                                        value={formData1.plate_code}
                                                        onChange={handleChange}
                                                        />
                {errors.plate_code && <p style={{ color: 'red' }}>{errors.plate_code}</p>}


              </div>

              <div className='col-md-4'>

                <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span>
                    Plate Registration Type<span style={{ color: "red" }}>*</span>
                  </span>
                  <span style={{ textAlign: "right", direction: "rtl" }}>
                    نوع تسجيل اللوحة 
                  </span>
                </label>
                <select name="plate_reg_type" style={{fontSize:"13px"}} className="form-control fs-3" value={formData1?.plate_reg_type} onChange={handleChange}>
        <option  style={{fontSize:"14px"}} value={""}>--select--</option>
        {reg_type.map((option, index) => (
          <option  style={{fontSize:"14px"}} key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
                {errors.plate_reg_type && <p style={{ color: 'red' }}>{errors.plate_reg_type}</p>} 


              </div>

            </div>
            <div className='row mb-3'>


                <div className="col-md-4">
                <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span>
                    Chasis No <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                  </span>
                  <span style={{ textAlign: "right", direction: "rtl" }}>
                    رقم الهيكل
                  </span>
                </label>
                <input
                                                type='text'
                                                className='form-control'
                                                name='chasis_no'
                                                value={formData1.chasis_no}
                                                onChange={handleChange}
                                                />
                                                {errors.chasis_no && <p style={{ color: 'red' }}>{errors.chasis_no}</p>}
               </div>

              <div className='col-md-4'>

                <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span>
                    Registration Mark<span style={{ color: "red" }}>*</span>
                  </span>
                  <span style={{ textAlign: "right", direction: "rtl" }}>
                     علامة التسجيل
                  </span>
                </label>
                <select ref={selectOpt1}  name="registration_mark" className="form-control" value={formData1?.registration_mark}  onChange={handleChange} >
        <option value={null}>--select--</option>
        {reg_mark.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
        </select>
        {errors.registration_mark && <p style={{ color: 'red' }}>{errors.registration_mark}</p>} 


              </div>

              <div className='col-md-4'>

                <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span>
                    Vehicle Value<span style={{ color: "red" }}>*</span>
                  </span>
                  <span style={{ textAlign: "right", direction: "rtl" }}>
                    قيمة السيارة 
                  </span>
                </label>
                <input
                                                type='text'
                                                className='form-control'
                                                name='vehicle_value'
                                                value={formData1.vehicle_value}
                                                onChange={handleChange}
                                                />
                                                {errors.vehicle_value && <p style={{ color: 'red' }}>{errors.vehicle_value}</p>}


              </div>

            </div>
            <div>
                            <button onClick={handleshow1}>Third Party</button>
                            <button style={{ marginLeft: '10px' }} onClick={handleshow2}>Comprehensive</button>
                        </div>

            
          </div>
          


                        </div>
                    </div>

                    {/* <div className="col-md-6 ">
                        <div>
                            <div className="row md-3">
                                <div className="col-md-6 text-start">
                                    <h2>Add Files</h2>
                                </div>
                                <div className="col-md-3 text-right">
                                    <h2>إضافة ملفات</h2>
                                </div>
                            </div>
                            <div className="inside_visa-form">
                                <div>
                                    <div className="col-md">
                                        <div className="row">
                                            <div className="col-md-6 text-start">
                                                <label>Driving License Front Side<span style={{ color: 'red' }}></span></label>
                                            </div>
                                            <div className="col-md-6 text-right">
                                                <label>رخصة القيادة على الجانب الأمامي</label>
                                            </div>
                                            <div class="file-upload-container">
                                                <label for="file-upload-1" class="file-upload-label" style={{ backgroundColor: '#66b0ff' }}>
                                                    Choose a file
                                                </label>
                                                <input type="file" id="file-upload-1" class="file-upload-input" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md">
                                        <div className="row">
                                            <div className="col-md-6 text-start">
                                                <label>Driving License Back Side<span style={{ color: 'red' }}>*</span></label>
                                            </div>
                                            <div className="col-md-6 text-right">
                                                <label>رخصة القيادة في الجانب الخلفي</label>
                                            </div>
                                            <div class="file-upload-container">
                                                <label for="file-upload-1" class="file-upload-label" style={{ backgroundColor: '#66b0ff' }}>
                                                    Choose a file
                                                </label>
                                                <input type="file" id="file-upload-1" class="file-upload-input" />
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div className="row">
                                                <div className="col-md-6 text-start">
                                                    <label>Mulkiya Front Side<span style={{ color: 'red' }}></span></label>
                                                </div>
                                                <div className="col-md-6 text-right">
                                                    <label>واجهة الملكية</label>
                                                </div>
                                                <div class="file-upload-container">
                                                    <label for="file-upload-1" class="file-upload-label" style={{ backgroundColor: '#66b0ff' }}>
                                                        Choose a file
                                                    </label>
                                                    <input type="file" id="file-upload-1" class="file-upload-input" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md">
                                            <div className="row">
                                                <div className="col-md-6 text-start">
                                                    <label>Mulkiya Back Side<span style={{ color: 'red' }}></span></label>
                                                </div>
                                                <div className="col-md-6 text-right">
                                                    <label>الملكية الجهة الخلفية</label>
                                                </div>
                                                <div class="file-upload-container" >
                                                    <label for="file-upload-1" class="file-upload-label" style={{ backgroundColor: '#66b0ff' }}>
                                                        Choose a file
                                                    </label>
                                                    <input type="file" id="file-upload-1" class="file-upload-input" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>

               

                    <div className="row mb-3">

                        {show1 && (

                            <div className="col-md-8">

                                <div className="">
                                    <div className="row mb-2 mt-4">
                                        <div className="col-md-6 text-start">
                                            <h2>Third Party</h2>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <h2>طرف ثالث</h2>
                                        </div>
                                    </div>
                                    <div className="inside_visa-form">
                                        <h4 className="px-0 py-2">{(lnstr === 'en') ? 'Select plan' : 'اختر الخطة\n'}</h4>

                                        <form>
                                            <div class="align-items-center travel-selection-option">
                                                {(lnstr === 'en') ? 'Basic + Driver + Family (PAB)' : 'أساسي + سائق + عائلة (PAB)\n'}
                                                <input type="radio" name="personalaccident" value="Basic + Driver + Family (PAB)" data-name="050008" className="d-inline-block option-circle ml-auto" onChange={handleOptionChange} />
                                            </div>

                                            <div class="align-items-center travel-selection-option my-3">
                                                {(lnstr === 'en') ? 'Basic + Driver + Family (PAB) + UAE' : 'أساسي + سائق + عائلة (PAB) + الإمارات العربية المتحدة\n'}<input type="radio" name="personalaccident" value="Basic + Driver + Family (PAB) + UAE" data-name="050009" className="d-inline-block option-circle ml-auto" onChange={handleOptionChange} />
                                            </div>
                                            <div class="align-items-center travel-selection-option my-3">
                                                {(lnstr === 'en') ? 'Basic + Driver + Family (PAB) + RSA' : 'أساسي + سائق + عائلة (PAB) + RSA\n'}
                                                <input type="radio" name="personalaccident" value="Basic + Driver + Family (PAB) + RSA" data-name="050017" className="d-inline-block option-circle ml-auto" onChange={handleOptionChange} />
                                            </div>
                                            <div class="align-items-center travel-selection-option my-3">
                                                {(lnstr === 'en') ? 'Basic + Driver + Family (PAB) + UAE + RSA' : 'أساسي + سائق + عائلأساسي + سائق + عائلة (PAB) + الإمارات العربية المتحدة + RSA\n'}
                                                <input type="radio" name="personalaccident" value="Basic + Driver + Family (PAB) + UAE + RSA" data-name="050018" className="d-inline-block option-circle ml-auto" onChange={handleOptionChange} />
                                            </div>
                                        </form>
                                        <div className="text-right">
                            <button onClick={createQuote}>Quote</button>
                        </div>
                                    </div>
                                </div>
                            </div>

                        )}




                        {show2 && (
                            <div className="col-md-8">

                                <div className="">
                                    <div className="row mb-2 mt-4">
                                        <div className="col-md-6 text-start">
                                            <h2>Comprehensive</h2>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <h2>شامل</h2>
                                        </div>
                                    </div>
                                    <div className="inside_visa-form">
                                        <h4 className="px-0 py-2">{(lnstr === 'en') ? 'Select plan' : 'اختر الخطة\n'}</h4>

                                        <form>
                                            <div class="align-items-center travel-selection-option" onClick={togglePopup}>
                                                {(lnstr === 'en') ? 'Basic + Medex + Driver + Family (PAB) + UAE' : 'أساسي + ميدكس + سائق + عائلة (PAB) + الإمارات العربية المتحدة\n'}
                                                <input type="radio" name="personalaccident" data-name="050012" value="Basic + Medex + Driver + Family (PAB) + UAE" className="d-inline-block option-circle ml-auto" onChange={handleOptionChange} />
                                            </div>

                                            <div class="align-items-center travel-selection-option my-3" onClick={togglePopup}>
                                                {(lnstr === 'en') ? 'Basic + Medex + Driver + Family (PAB)' : 'أساسي + ميديكس + سائق + عائلة (PAB)\n'}
                                                <input type="radio" name="personalaccident" data-name="050004" value="Basic + Medex + Driver + Family (PAB)" className="d-inline-block option-circle ml-auto" onChange={handleOptionChange} />
                                            </div>
                                            <div class="align-items-center travel-selection-option my-3" onClick={togglePopup}>
                                                {(lnstr === 'en') ? 'Basic + Medex + Driver + Family (PAB) + RSA' : 'أساسي + ميديكس + سائق + عائلة (PAB) + RSA\n'}
                                                <input type="radio" name="personalaccident" value="Basic + Medex + Driver + Family (PAB) + RSA" data-name="050013" className="d-inline-block option-circle ml-auto" onChange={handleOptionChange} />
                                            </div>
                                            <div class="align-items-center travel-selection-option my-3" onClick={togglePopup}>
                                                {(lnstr === 'en') ? 'Basic + Medex + Driver + Family (PAB) + UAE + RSA' : 'أساسي + ميديكس + سائق + عائلة (PAB) + الإمارات العربية المتحدة + RSA\n'}
                                                <input type="radio" name="personalaccident" value="Basic + Medex + Driver + Family (PAB) + UAE + RSA" data-name="050014" className="d-inline-block option-circle ml-auto" onChange={handleOptionChange} />
                                            </div>
                                            {isOpen && <Popup onClose={togglePopup} />}
                                        </form>
                                        <div className="text-right">
                            <button onClick={createQuote}>Quote</button>
                        </div>
                                    </div>
                                </div>
                            </div>

                        )}
                     

                    </div>
                    </>
                }

     {/* all details display ; */}


{ 
 ( openPaymentOption&& quoteDetails ) &&
     <div className="row d-flex ">
 
 <div className="col-md-6">
 <div className="d-flex justify-content-between ">
                            <h2>Vehicle Details</h2>
                            <h2>تفاصيل السيارة</h2>
                        </div>
  <div className="w-100 ">
                         <div className="card  w-100">
                          <table className="w-100 mt-3">
                          <tbody>
                           {/* model */}
                          <tr>
                         
                            <td><h5 className="pl-3"><strong>Model</strong></h5></td>
                            <td>
                           <h5>: {vehicleDetails?.make} ({vehicleDetails?.modelYear})</h5>
                            </td>
                            </tr>

{/* vehicle no */}
                            <tr>
  <td><h5 className="pl-3"><strong>Vehicle No</strong></h5></td>
                              <td><h5>: {vehicleDetails?.vehRegNo} {vehicleDetails?.vehRegLOC}</h5></td>
                            </tr>

                            {/* chassis no */}


                               <tr>
  <td><h5 className="pl-3"><strong>Chassis No</strong></h5></td>
                              <td><h5>: {vehicleDetails?.chasisNo}</h5></td>
                            </tr>

                         {/* body type  */}

 <tr>
  <td><h5 className="pl-3"><strong>Body Type</strong></h5></td>
                              <td><h5>: {vehicleDetails?.vehBody}</h5></td>
                            </tr>

                                      {/* usage type  */}

                          <tr>
  <td><h5 className="pl-3"><strong>Usage Type</strong></h5></td>
                              <td><h5>: {vehicleDetails?.usage}</h5></td>
                            </tr>



                            </tbody>
                        </table>
                        </div>
                          <div>

                          </div>                      
       </div>

     </div>

<div className="col-md-6">
    <div className="d-flex justify-content-between ">
                            <h2>Insured  Details</h2>
                            <h2>تفاصيل المؤمن عليه</h2>
                        </div>
  <div className="w-100 ">
                         <div className="card  w-100">
                          <table className="w-100 mt-3">
                          <tbody>
                           {/* model */}
                          <tr>
                         
                            <td><h5 className="pl-3"><strong>Insured Name</strong></h5></td>
                            <td>
                           <h5>: {insuredDetails?.insureFullName}</h5>
                            </td>
                            </tr>

{/* vehicle no */}
                            <tr>
  <td><h5 className="pl-3"><strong>Civil Id</strong></h5></td>
                              <td><h5>: {insuredDetails?.insuredLicNo}</h5></td>
                            </tr>

                            {/* chassis no */}


                               <tr>
  <td><h5 className="pl-3"><strong>Age</strong></h5></td>
                              <td><h5>: {insuredDetails?.insuredAge}</h5></td>
                            </tr>



                            </tbody>
                        </table>
                        </div>
                          <div>

                          </div>                      
       </div>
</div>

<div className="col-md-12 mt-3">
    <div className="d-flex justify-content-between ">
                            <h2>Quote Details</h2>
                            <h2>تفاصيل الاقتباس</h2>
                        </div>
  <div className="w-100 ">
                         <div className="card w-100">
                          <table className="w-100 mt-3">
                          <tbody>
                           {/* model */}
                          <tr>
                            <td><h5 className="pl-3"><strong>Quote No</strong></h5></td>
                            <td>
                           <h5>: {quoteDetails?.renewalQuoteNo || transactionDetails?.quoteNo}</h5>
                            </td>
                            </tr>


<tr>
                            <td><h5 className="pl-3"><strong>Cover From Date</strong></h5></td>
                            <td>
                           <h5>: {quoteDetails?.effectiveDt}</h5>
                            </td>
                            </tr>


                            
<tr>
                            <td><h5 className="pl-3"><strong>Cover To Date</strong></h5></td>
                            <td>
                           <h5>: {quoteDetails?.expirationDt}</h5>
                            </td>
                            </tr>



<tr>
 <td><h5 className="pl-3"><strong>Product</strong></h5></td>
                            <td>
                           <h5>: {quoteDetails?.prodId}</h5>
                            </td>
                            </tr>

                            <tr>
 <td><h5 className="pl-3"><strong>Plan</strong></h5></td>
                            <td>
                           <h5>: {quoteDetails?.planSelection}</h5>
                            </td>
                            </tr>


<tr>
 <td><h5 className="pl-3"><strong>Obtained Cover</strong></h5></td>
                            <td>
                           <h5>: {quoteDetails?.obtainedCvr}</h5>
                            </td>
                            </tr>

  
                       
                   

                            </tbody>
                        </table>
                        </div>
                          <div>

                          </div>                      
       </div>
</div>
<div className="col-12">
  <div className="d-flex gap-3 mt-3">
     <h2 className="mr-3">NET PREMIUM (Including VAT & all other taxes)</h2>
     <h2><strong>: {quoteDetails?.premiumAmt} OMR</strong></h2>
  </div>


  {/* make payment */}
<button className="mb-3" onClick={(e)=>{makePayment(e)}}>
  Make Payment
</button>

  </div>
    </div>

  }
             
  
            
        
            </form>

            


        </Fragment>
:
<div style={{
            width: '100vw',
            height: '100vh',
            border: 'none',
            textAlign: 'center',
            marginTop: '25%',
            fontSize: '20px',
            fontWeight: 'bold'
        }}>  {isHidePage == '' ? "Loading" : "Token Invalid"}</div>
    );
}

export default SanadMotor;